import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ad23cba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-editor-section-control" }
const _hoisted_2 = {
  key: 0,
  class: "section-name"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldGrid = _resolveComponent("FieldGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.section.name !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.section.name), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_FieldGrid, {
      class: "fields",
      rows: _ctx.section.layout.rows,
      cols: _ctx.section.layout.cols,
      properties: _ctx.properties,
      onExecute: _cache[0] || (_cache[0] = c => _ctx.$emit('execute', c))
    }, null, 8, ["rows", "cols", "properties"])
  ]))
}